import { useEffect, useState } from "react";

import styles from "../../../../styles/size-step.module.scss";

import { Icon } from "../../../components/core/Icon";

import classNames from "classnames/bind";

import { Picture } from "../../../components/Icons";
import { Drawer } from "../../../components/Drawer";
import { InputSearch } from "../../../components/InputSearch";
import { Button } from "../../../components/Button";

export const categoryIcons = [
  { name: "Lula", icon: <Icon name="fa-squid" light /> },
  { name: "Carne", icon: <Icon name="fa-steak" light /> },
  { name: "Sushi", icon: <Icon name="fa-sushi" light /> },
  { name: "Sushi", icon: <Icon name="fa-sushi-roll" light /> },
  { name: "Taco", icon: <Icon name="fa-taco" light /> },
  { name: "Assado", icon: <Icon name="fa-turkey" light /> },
  { name: "Whisky", icon: <Icon name="fa-whiskey-glass-ice" light /> },
  { name: "Vinho", icon: <Icon name="fa-wine-bottle" light /> },
  { name: "Vinho", icon: <Icon name="fa-wine-glass-empty" light /> },
  { name: "Vinho", icon: <Icon name="fa-wine-glass" light /> },
  { name: "Donut", icon: <Icon name="fa-bagel" light /> },
  { name: "Baguete", icon: <Icon name="fa-baguette" light /> },
  { name: "Cerveja", icon: <Icon name="fa-beer-mug" light /> },
  { name: "Carne", icon: <Icon name="fa-bone" light /> },
  {
    name: "Macarrão",
    icon: <Icon name="fa-bowl-chopsticks-noodles" light />,
  },
  { name: "Refeição", icon: <Icon name="fa-bowl-food" light /> },
  { name: "Refeição", icon: <Icon name="fa-bowl-hot" light /> },
  { name: "Refeição", icon: <Icon name="fa-bowl-rice" light /> },
  { name: "Refeição", icon: <Icon name="fa-bowl-scoops" light /> },
  { name: "Refeição", icon: <Icon name="fa-bowl-soft-serve" light /> },
  { name: "Pão", icon: <Icon name="fa-bread-loaf" light /> },
  { name: "Pão", icon: <Icon name="fa-bread-slice-butter" light /> },
  { name: "Hamburguer", icon: <Icon name="fa-burger-cheese" light /> },
  { name: "Hamburguer", icon: <Icon name="fa-burger-fries" light /> },
  { name: "Hamburguer", icon: <Icon name="fa-burger-glass" light /> },
  { name: "Hamburguer", icon: <Icon name="fa-burger-lettuce" light /> },
  { name: "Hamburguer", icon: <Icon name="fa-burger" light /> },
  { name: "Hamburguer", icon: <Icon name="fa-burger-soda" light /> },
  { name: "Burrito", icon: <Icon name="fa-burrito" light /> },
  { name: "Bolo", icon: <Icon name="fa-cake-candles" light /> },
  { name: "Bolo", icon: <Icon name="fa-cake-slice" light /> },
  { name: "Doce", icon: <Icon name="fa-candy-cane" light /> },
  { name: "Queijo", icon: <Icon name="fa-cheese-swiss" light /> },
  { name: "Biscoito", icon: <Icon name="fa-cookie" light /> },
  { name: "Milho", icon: <Icon name="fa-corn" light /> },
  { name: "Carangueijo", icon: <Icon name="fa-crab" light /> },
  { name: "Croissant", icon: <Icon name="fa-croissant" light /> },
  { name: "Cupcake", icon: <Icon name="fa-cupcake" light /> },
  { name: "Bebida", icon: <Icon name="fa-cup-straw-swoosh" light /> },
  { name: "Donut", icon: <Icon name="fa-donut" light /> },
  { name: "Ovo", icon: <Icon name="fa-egg-fried" light /> },
  { name: "Peixe", icon: <Icon name="fa-fish-fins" light /> },
  { name: "Fondue", icon: <Icon name="fa-fondue-pot" light /> },
  { name: "Bebida", icon: <Icon name="fa-glass" light /> },
  { name: "Batata", icon: <Icon name="fa-french-fries" light /> },
  { name: "Hotdog", icon: <Icon name="fa-hotdog" light /> },
  { name: "Sorvete", icon: <Icon name="fa-ice-cream" light /> },
  { name: "Lagosta", icon: <Icon name="fa-lobster" light /> },
  { name: "Doces", icon: <Icon name="fa-lollipop" light /> },
  { name: "Drink", icon: <Icon name="fa-martini-glass" light /> },
  { name: "Carne", icon: <Icon name="fa-meat" light /> },
  { name: "Chá", icon: <Icon name="fa-mug-hot" light /> },
  { name: "Chá", icon: <Icon name="fa-mug-saucer" light /> },
  { name: "Chá", icon: <Icon name="fa-mug-tea-saucer" light /> },
  { name: "Panqueca", icon: <Icon name="fa-pancakes" light /> },
  { name: "Refeição", icon: <Icon name="fa-pan-food" light /> },
  { name: "Torta", icon: <Icon name="fa-pie" light /> },
  { name: "Pizza", icon: <Icon name="fa-pizza-slice" light /> },
  { name: "Pipoca", icon: <Icon name="fa-popcorn" light /> },
  { name: "Refeição", icon: <Icon name="fa-pot-food" light /> },
  { name: "Pretzel", icon: <Icon name="fa-pretzel" light /> },
  { name: "Salada", icon: <Icon name="fa-salad" light /> },
  { name: "Camarão", icon: <Icon name="fa-shrimp" light /> },
  { name: "Sanduíche", icon: <Icon name="fa-sandwich" light /> },
];

export default function SelectIconCategory({ mountPayload, categoryIcon }) {
  const cx = classNames.bind(styles);

  const [openIconsList, setOpenIconsList] = useState(false);
  const [icon, setIcon] = useState(null);
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [occurrences, setOccurrences] = useState(0);
  const [icons, setIcons] = useState([]);

  useEffect(() => {
    setIcons(categoryIcons);
  }, []);

  const searchCategory = (e) => {
    const searchTerm = (e.target.value || "").toLowerCase();

    if (searchTerm.length > 1) {
      const filteredIcons = icons.filter(
        (icon) => (icon.name || "").toLowerCase().indexOf(searchTerm) > -1
      );

      setOccurrences(filteredIcons.length);
      setIcons(filteredIcons);
    } else {
      setOccurrences(null);
      setIcons(categoryIcons);
    }
  };

  return (
    <>
      <div className={styles.chooseIconContainer}>
        <div
          className={styles.chooseIcon}
          onClick={() => setOpenIconsList(true)}
        >
          <div
            className={cx({
              icon: true,
              selected: selectedIcon || categoryIcon,
            })}
          >
            {categoryIcon ? (
              <Icon name={categoryIcon} light />
            ) : selectedIcon ? (
              <Icon name={selectedIcon} light />
            ) : (
              <Picture />
            )}
          </div>
          <div className="d-flex flex-column">
            <p>Ícone desta categoria</p>
            <span>{icons.length} ícones disponíveis.</span>
          </div>
        </div>
      </div>

      <Drawer
        visible={openIconsList}
        title="Selecionar ícone para categoria"
        onClose={() => setOpenIconsList(false)}
        withoutTransition
        withoutFade
        showBackButton
        backButton={() => setOpenIconsList(false)}
      >
        <InputSearch
          placeholder="Buscar por..."
          occurrences={occurrences || null}
          onChange={(e) => searchCategory(e)}
          className="mb-20"
        />

        <div className={styles.scrollContainer}>
          <div className={styles.categoryIcons}>
            {icons.map((item) => {
              const iconName = item.icon.props.name;

              return (
                <div
                  className={cx({
                    icon: true,
                    selected: iconName === icon,
                  })}
                  onClick={() => setIcon(iconName)}
                >
                  {item.icon}
                </div>
              );
            })}
          </div>
        </div>

        <div className={styles.footer}>
          <Button
            className="mb-10"
            design="primary"
            onClick={() => {
              setOpenIconsList(false);
              setSelectedIcon(icon);
              mountPayload(icon);
            }}
            disabled={!icon}
          >
            Selecionar ícone
          </Button>
          <Button
            design="default"
            onClick={() => {
              setOpenIconsList(false);
              setSelectedIcon(null);
              setIcon(null);
              mountPayload(icon);
            }}
          >
            Continuar sem ícone
          </Button>
        </div>
      </Drawer>
    </>
  );
}
